export class PMRType {
    id: number;
    name: string;

    constructor(apiResult: any) {
        this.id = apiResult.id;
        this.name = apiResult.name;
    }
}